// 작업 단위 요약(`units`) wire 계약의 경계다.
//
// 작업 단위는 Worker 하나가 한 번에 점유하는 일의 묶음이다. 종류는 셋이다:
//   - window: video 진단의 구간이다. 구간 하나에 대상 에피소드가 최대 100개 있다. 여러 Worker 가
//             서로 다른 구간을 동시에 처리한다.
//   - chunk:  업로드 청크다. Worker 하나가 청크를 차례로 복사하고 확정한다.
//   - job:    parquet·aggregate 진단이다. 작업 전체가 단위 하나다.
//
// 전체 단위 수(`total`)는 3-상태다:
//   - null: 아직 셀 수 없다. 예) 업로드가 원본 목록을 만드는 중이다.
//   - 수이고 `total_final` 이 false: 추정값이다. BE 는 claim 때 구간을 하나씩 만든다. 그래서 할당이
//     끝나기 전에는 남은 대상 수로 전체 구간 수를 추정한다.
//   - 수이고 `total_final` 이 true: 확정값이다.
// 추정값을 확정값처럼 표시하면 운영자가 전체 규모를 잘못 읽는다. 그래서 소비처는
// `readWorkUnitTotal` 로만 total 을 읽는다.
//
// Owns:
// - `WorkUnitSummary` wire 타입과 total 3-상태의 의미.
// - total 판독(`readWorkUnitTotal`).
//
// Does not own:
// - 상태별 단위 수. BE 가 센다.
// - 화면 문구. 페이지 포맷터가 판독 결과로 만든다.

export type WorkUnitKind = "window" | "chunk" | "job";

export type WorkUnitSummary = {
  kind: WorkUnitKind;
  total: number | null;
  total_final: boolean;
  queued: number;
  running: number;
  done: number;
  failed: number;
  cancelled: number;
};

export type WorkUnitTotal =
  | { state: "unknown" }
  | { state: "estimate"; value: number }
  | { state: "final"; value: number };

/** 전체 단위 수를 3-상태로 읽는다. total 이 null 이면 `total_final` 과 관계없이 unknown 이다. */
export function readWorkUnitTotal(
  summary: Pick<WorkUnitSummary, "total" | "total_final">,
): WorkUnitTotal {
  if (summary.total === null) {
    return { state: "unknown" };
  }
  return summary.total_final
    ? { state: "final", value: summary.total }
    : { state: "estimate", value: summary.total };
}
